import { device } from 'constants/responsive'
import InfiniteScroll from 'react-infinite-scroll-component'
import styled, { css } from 'styled-components'

export const Wrapper = styled(InfiniteScroll)<{ grid: boolean; oneColumn?: boolean }>`
  overflow: visible !important;
  position: relative;

  padding-bottom: 45px;

  ${({ grid, oneColumn }) =>
    grid &&
    css`
      display: grid;
      grid-template-columns: repeat(${oneColumn ? 1 : 2}, 1fr);
      grid-template-rows: 1fr;
      grid-column-gap: 14px;
      grid-row-gap: 14px;

      @media ${device.laptopL} {
        grid-template-columns: repeat(2, 1fr);
      }

      @media ${device.tablet} {
        grid-template-columns: 1fr;
      }
    `}
`

export const LoaderWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  right: 50%;
  transform: translateX(50%);
  display: flex;
  justify-content: center;
`
